// extracted by mini-css-extract-plugin
export var originalPrice = "_v5-0";